import { updateTransferApi } from "./updateTransferApi";

export const updateTransferSetData = async (
  lang,
  setMessageResponse,
  cookies,
  transferId,
  credintial,
  setSuccessMessage,
  setBtnLoader
) => {
  const response = await updateTransferApi(
    credintial,
    lang,
    cookies,
    transferId
  );
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      data: response.res.data,
    }));
    setBtnLoader(() => false);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
      setBtnLoader(() => false);
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
      setBtnLoader(() => false);
    }
  }
};
